import { protectedComponentHoc } from "../../components/ProtectedComponent";
import InsuredComponent from "./component";

export const Insured = protectedComponentHoc(InsuredComponent);
